
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
} from "@chakra-ui/react";

const CommonModal = ({ isOpen, onClose, title, childComponent, buttonTitle = 'Close' }) => {


    return (

        <Modal isOpen={isOpen} onClose={() => {
            if (buttonTitle === 'Save') {
                onClose(false);
            } else {
                onClose(false);
            }
        }}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {childComponent}
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={() => {
                        if (buttonTitle === 'Save') {
                            onClose(true);
                        } else {
                            onClose(false);
                        }
                    }}>
                        {buttonTitle}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default CommonModal;